var version = require("../../package.json").version;

module.exports = ["dwolla-v2-node", version].join(" ");
